import { CUSTOM_LINK_FIELDS } from '../../../../../../constants';

export const CUSTOM_LINK_DIALOG_MODES = {
  ADD: 'add',
  EDIT: 'edit',
};

export const CUSTOM_LINK_DIALOG = {
  [CUSTOM_LINK_DIALOG_MODES.ADD]: {
    TITLE: 'Add Custom Link',
    PRIMARY_BUTTON_TEXT: 'Add Link',
  },
  [CUSTOM_LINK_DIALOG_MODES.EDIT]: {
    TITLE: 'Edit Custom Link',
    PRIMARY_BUTTON_TEXT: 'Save Changes',
  },
};

export const CUSTOM_LINK_LABELS = {
  [CUSTOM_LINK_FIELDS.TITLE]: 'Title',
  [CUSTOM_LINK_FIELDS.URL]: 'Link',
};

export const CUSTOM_LINK_VALIDATION_ERROR_MESSAGES = {
  TITLE: {
    REQUIRED: 'Title is required',
  },
  URL: {
    REQUIRED: 'Link is required',
    INVALID: 'Enter a valid URL starting with https://',
  },
};
